import { styled } from 'goober';

import { colorIcon } from '../icons/functions';

import type { TabVariant } from './types';

interface TabControlProps {
  isActive: boolean;
  onClick: () => void;
  title: React.ReactNode;
  variant: TabVariant;
}

export const TabControl = ({
  isActive,
  onClick,
  title,
  variant,
}: TabControlProps) => (
  <TabControlWrapper isActive={isActive} onClick={onClick} variant={variant}>
    {title}
  </TabControlWrapper>
);

const TabControlWrapper = styled('div')<{
  isActive?: boolean;
  variant: TabVariant;
}>`
  margin-bottom: -1px;
  display: inline-flex;
  align-items: center;
  line-height: 20.3px;
  padding: ${({ theme, variant }) =>
    theme.palettes.component.tabs[variant].padding};

  color: ${({ theme, variant }) => theme.palettes.component.tabs[variant].main};

  font-size: 14px;
  line-height: 145%;
  ${({ theme, variant }) => {
    const transition = theme.palettes.component.tabs[variant].transition;
    return transition ? `transition: ${transition};` : '';
  }}
  ${({ theme, variant }) =>
    colorIcon(theme.palettes.component.tabs[variant].main)};
  border-bottom: 1px solid transparent;

  ${({ isActive, theme, variant }) => {
    const tokens = theme.palettes.component.tabs[variant];
    return (
      isActive &&
      `
      border-bottom: 2px solid ${tokens.active};
      font-weight: ${tokens.activeFontWeight};
      color: ${tokens.active};
      ${colorIcon(tokens.active)}
    `
    );
  }}

  &:hover {
    cursor: pointer;
    ${({ isActive, theme, variant }) => {
      if (isActive) {
        return '';
      }

      const tokens = theme.palettes.component.tabs[variant];

      if (tokens.inactiveHoverKind === 'text' && tokens.inactiveHoverColor) {
        return `
        color: ${tokens.inactiveHoverColor};
        ${colorIcon(tokens.inactiveHoverColor)}
      `;
      }

      return `
        border-color: ${tokens.main};
      `;
    }}
  }
`;
